<template>
    <place-order :isSalesAgent="false"/>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>